import { Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { texFieldDefaultColumnProps } from "../../../../Forms/TextFieldDefaultProps";
import { isElementInArray } from "../../../../Utils/arrays";
import { nameOf } from "../../../../Utils/nameOf";
import { RateAgreement } from "../../RateAgreement";
import { CarrierSelect } from "../../../../Carrier/CarrierSelect";
import { RHFDatePicker } from "../../../../Forms/RHFDatePicker";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";

export const RateAgreementDetails = ({ disabledFields }: MdmFormProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RateAgreement>();

  return (
    <BorderedFormGrid>
      {/* FIRST COLUMN */}
      <Grid container item xs={4} direction="column">
        <Controller
          name={nameOf<RateAgreement>("CarrierId")}
          control={control}
          render={({ field }) => (
            <CarrierSelect
              field={field}
              error={!!errors?.CarrierId}
              errorMessage={errors.CarrierId?.message}
              disabled={isElementInArray(disabledFields, nameOf<RateAgreement>("CarrierId"))}
              required
            />
          )}
        />
        <RHFDatePicker control={control} name="StartDate" label="Start Date" direction="column" />
        <RHFDatePicker control={control} name="EndDate" label="End Date" direction="column" />
      </Grid>

      {/* SECOND COLUMN */}
      <Grid container item xs={4} direction="column" rowSpacing={4}>
        <TextFieldInput
          {...texFieldDefaultColumnProps}
          name="Description"
          control={control}
          multiline
          rows={4}
          direction="column"
          disabledFields={disabledFields}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
